module.exports = __webpack_public_path__ + "static/media/people-1.30c78132.jpg";